export default "__VITE_ASSET__BP$nSuS7__"